import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {Subject} from 'rxjs';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatCalendar, MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import {default as _rollupMoment, Moment} from 'moment';
import { IDatepickerOption } from '../../../models/IDatepickerOption';
import { FormControl } from '@angular/forms';
import moment from 'moment';

//Formats from moment.js
export const MY_FORMATS_TEXT = {
  parse: {
    dateInput: 'MMMM Do',
  },
  display: {
    dateInput: 'MMMM Do',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    
  },
};


@Component({
  selector: 'ff-datepicker-text',
  templateUrl: './datepicker-text.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  styleUrls: ['./datepicker-text.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_TEXT},
  ],
})
export class DatepickerTextComponent implements OnInit {

  ffDatepickerHeaderText = FFDatepickerHeaderText;

    /**
     * Options to configure min and max date to datepicker
     * Use the IDatepickerOption interface: { minDate: Date, maxDate: Date }
     * * @internal
    */
     @Input() options?: IDatepickerOption;

     /**
     * Options to enable ordisable the datepicker
     * * @internal
    */
    @Input() isDisabled?: boolean;

     /**
      * Return the selection updated each time the user choses a new date.
      * * @internal
     */
    @Output() selection = new EventEmitter<Date> ();
  

    //variable date that will be used as the output
    date = new Date();

    //form control to show selected date in the input
    formDate = new FormControl();

    minDate : Date = new Date(0);
    maxDate : Date = new Date();
    

  constructor(
  ) { }

  ngOnInit() {
    if (this.options !== undefined){
      this.minDate = this.options.minDate !== undefined ? this.options.minDate : this.minDate;

      //If there is no input with maxDate parameter, maxDate will be 30 years from the present date
      if (this.options.maxDate !== undefined){
        this.maxDate = this.options.maxDate
      } else {
        this.maxDate.setFullYear(this.maxDate.getFullYear() + 30);
      }
    } else {
      this.maxDate.setFullYear(this.maxDate.getFullYear() + 30);
    }

    this.isDisabled = this.isDisabled !== undefined ? this.isDisabled : false;
  }

  
  ngOnChanges() {
    if (this.isDisabled){
      this.formDate.disable();
    } else {
      this.formDate.enable();
    }
  }



  //Handles year selection
  chosenDateHandler(event: MatDatepickerInputEvent<Date>) {
    this.date = event.value;
    this.selection.emit(this.date);

  }
}



/** Custom header component for datepicker. */
@Component({
  selector: 'ff-datepicker-header',
  styles: [`
    .dp-header {
      padding: 0.5em;
      background-color: #c81414;
      color: white;
      height: 4em;
      border-radius: 4px;
    }

    .year-header-label {
      font-weight: 100;
      text-align: center;
      padding: 14px;
      opacity: 0.7;
    }

    .dp-year {
      margin-bottom: -9px;
      margin-top: 3px;
    }

    .month-header-label {
      font-weight: 400;
      text-align: center;
      padding: 14px;
      font-size: 1.2em;
    }

    .selector-container {
      justify-content: space-between;
      background-color: #c81414;
      border-radius: 5px;
    }

    .button-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 96%;
      background-color: white;
      padding: 15px 5px 15px;
    }

    .btn-selector {
      background-color: white;
      color: black;
      width: 10%;
      border-style: none;
      display: flex;
      margin-right: 6%;
    }

    .btn-selector-double-arrow {
      background-color: white;
      color: black;
      width: 10%;
      border-style: none;
      display: flex;
      margin-top: 10px;
    }

    .btn-selector-double-arrow .mat-icon {
      margin: -85%;
    }

    .label-header {
      margin-top: 2px;
      font-size: 14px;
    }

    .btn-selector:hover, .btn-selector-double-arrow:hover {
      transform:scale(1.3,1.3);
    }
  `],
  templateUrl: '../headers/datepicker-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FFDatepickerHeaderText<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
      private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>) {
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  //Gets year label to use it in the header
  get yearLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, 'YYYY');
  }

  //Gets month label to use it in the header
  get monthLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, "MMMM");
  }

  get dateLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, "ddd, MMM D");
  }

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
        this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) :
        this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
        this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) :
        this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }


} 


